import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d2eb77f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = { class: "p-mx-2" }
const _hoisted_5 = { class: "p-mx-2" }
const _hoisted_6 = { class: "st-style p-text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_8 = { class: "p-buttonset" }
const _hoisted_9 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_10 = { class: "p-grid" }
const _hoisted_11 = { class: "p-col" }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "p-error" }
const _hoisted_17 = {
  key: 1,
  class: "p-error"
}
const _hoisted_18 = { class: "p-field" }
const _hoisted_19 = {
  key: 0,
  class: "p-error"
}
const _hoisted_20 = { class: "p-field" }
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}
const _hoisted_22 = { class: "p-col" }
const _hoisted_23 = {
  key: 0,
  class: "p-field"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" TITLE : ")
const _hoisted_25 = { class: "pull-right" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_27 = { class: "pull-right" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_29 = { class: "pull-right" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_31 = { class: "pull-right" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "p-error" }
const _hoisted_34 = {
  key: 1,
  class: "p-error"
}
const _hoisted_35 = { class: "p-field" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Head Code : ")
const _hoisted_37 = { class: "pull-right" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Head Name : ")
const _hoisted_39 = { class: "pull-right" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Nature : ")
const _hoisted_41 = { class: "pull-right" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Head Type : ")
const _hoisted_43 = { class: "pull-right" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "p-error" }
const _hoisted_46 = {
  key: 1,
  class: "p-error"
}
const _hoisted_47 = { class: "p-field" }
const _hoisted_48 = {
  key: 0,
  class: "p-error"
}
const _hoisted_49 = { class: "p-field" }
const _hoisted_50 = {
  key: 0,
  class: "p-error"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "p-dialog-titlebar p-dialog-titlebar-icon" }, " Update cheque status ", -1))
const _hoisted_52 = { class: "p-grid" }
const _hoisted_53 = { class: "p-col" }
const _hoisted_54 = { class: "p-field" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Activity Type", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SearchFilter = _resolveComponent("SearchFilter")!
  const _component_PreviewBankingReceipt = _resolveComponent("PreviewBankingReceipt")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.itemFilter.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemFilter.type) = $event)),
              options: _ctx.bankingTypes,
              optionLabel: "key",
              optionValue: "value",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadList(0)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.itemFilter.keyword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemFilter.keyword) = $event)),
              modelModifiers: { trim: true },
              placeholder: "Receipt No"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              icon: "pi pi-search ",
              class: "p-button-primary p-mr-1",
              onClick: _ctx.loadSearchData
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              icon: "pi pi-calendar",
              class: "p-button-warning",
              onClick: _ctx.openFilterDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              class: "p-button-success",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("b", null, _toDisplayString(_ctx.statement), 1)
      ]),
      _createVNode(_component_DataTable, {
        first: _ctx.goToFirstLink,
        "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
        firstModifiers: { sync: true },
        value: _ctx.lists,
        dataKey: "id",
        ref: "dt",
        lazy: true,
        paginator: _ctx.checkPagination,
        rows: _ctx.limit,
        totalRecords: _ctx.totalRecords,
        resizableColumns: true,
        columnResizeMode: "expand",
        responsiveLayout: "scroll",
        onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPage($event))),
        class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
      }, {
        empty: _withCtx(() => [
          _hoisted_7
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "Created Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.created_at)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Updated Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.updated_at)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Receipt Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.receipt_date)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "receipt_no",
            header: "Receipt No"
          }),
          _createVNode(_component_Column, { header: "Account Title" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.profile_name.profileName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Total Amount" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(slotProps.data.amount)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "description",
            header: "Description"
          }),
          _createVNode(_component_Column, {
            field: "user_name.userName",
            header: "Created By"
          }),
          _createVNode(_component_Column, { header: "Store Name" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.branch.branchName) + " ( " + _toDisplayString(slotProps.data.branch.branchCode) + " ) ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Status" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.status), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            exportable: false,
            header: "Action"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_Button, {
                  icon: "pi pi-pencil",
                  class: "p-button-rounded p-button-success",
                  onClick: ($event: any) => (_ctx.editIem(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-print",
                  class: "p-button-rounded p-button-primary",
                  onClick: ($event: any) => (_ctx.openPreviewDialog(slotProps.data))
                }, null, 8, ["onClick"]),
                (slotProps.data.type == 'CHQ')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "pi pi-cog",
                      class: "p-button-rounded p-button-warning",
                      onClick: ($event: any) => (_ctx.openActivityDialog(slotProps.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["first", "value", "paginator", "rows", "totalRecords"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '70vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.dialogTitle), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Save",
            icon: "pi pi-check",
            class: "p-button-primary",
            onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"])),
            disabled: 
              (_ctx.item.profileID == 0 && _ctx.v$.selectedProfile.$model != 'None') ||
              _ctx.item.accountID == 0 ||
              _ctx.v$.amount.$model <= 0
            
          }, null, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", {
                  for: "type",
                  class: _normalizeClass({ 'p-error': _ctx.v$.type.$invalid && _ctx.submitted })
                }, "Activity Type", 2),
                _createVNode(_component_Dropdown, {
                  id: "type",
                  modelValue: _ctx.v$.type.$model,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.type.$model) = $event)),
                  options: _ctx.bankingTypes,
                  optionLabel: "key",
                  onChange: _ctx.setDefaultProfiler,
                  autoFocus: ""
                }, null, 8, ["modelValue", "options", "onChange"]),
                (
                  (_ctx.v$.type.$invalid && _ctx.submitted) || _ctx.v$.type.$pending.$response
                )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.v$.type.required.$message.replace("Value", "Type")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", {
                  for: "receiptDate",
                  class: _normalizeClass({ 'p-error': _ctx.v$.receiptDate.$invalid && _ctx.submitted })
                }, "Receipt Date", 2),
                _createVNode(_component_Calendar, {
                  id: "receiptDate",
                  modelValue: _ctx.v$.receiptDate.$model,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.receiptDate.$model) = $event)),
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.receiptDate.$invalid && _ctx.submitted }),
                  selectionMode: "single",
                  dateFormat: "dd-mm-yy"
                }, null, 8, ["modelValue", "class"]),
                (_ctx.v$.receiptDate.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.receiptDate.$errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          id: "p-error",
                          key: index
                        }, [
                          _createElementVNode("small", _hoisted_16, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (
                  (_ctx.v$.receiptDate.$invalid && _ctx.submitted) ||
                  _ctx.v$.receiptDate.$pending.$response
                )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_ctx.v$.receiptDate.required.$message.replace("Value", "Date")), 1))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", {
                  for: "bankID",
                  class: _normalizeClass({ 'p-error': _ctx.v$.bankID.$invalid && _ctx.submitted })
                }, "Bank", 2),
                _createVNode(_component_Dropdown, {
                  id: "bankID",
                  modelValue: _ctx.v$.bankID.$model,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.bankID.$model) = $event)),
                  options: _ctx.bankList,
                  optionLabel: "bank",
                  optionValue: "id",
                  filter: true,
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.bankID.$invalid && _ctx.submitted })
                }, null, 8, ["modelValue", "options", "class"]),
                (
                  (_ctx.v$.bankID.$invalid && _ctx.submitted) ||
                  _ctx.v$.bankID.$pending.$response
                )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.v$.bankID.required.$message.replace("Value", "Bank")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", {
                  for: "amount",
                  class: _normalizeClass({ 'p-error': _ctx.v$.amount.$invalid && _ctx.submitted })
                }, " Amount (" + _toDisplayString(_ctx.currency) + ")", 3),
                _createVNode(_component_InputNumber, {
                  useGrouping: false,
                  mode: "decimal",
                  maxFractionDigits: 2,
                  minFractionDigits: 2,
                  id: "amount",
                  modelValue: _ctx.v$.amount.$model,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.amount.$model) = $event)),
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.amount.$invalid && _ctx.submitted })
                }, null, 8, ["modelValue", "class"]),
                (
                  (_ctx.v$.amount.$invalid && _ctx.submitted) ||
                  _ctx.v$.amount.$pending.$response
                )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.v$.amount.required.$message.replace("Value", "Amount")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_ctx.v$.type.$model.key != 'Bank Deposit' && _ctx.v$.type.$model.key != 'Bank Expense')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("label", {
                      for: "selectedProfile",
                      class: _normalizeClass({ 'p-error': _ctx.v$.selectedProfile.$invalid && _ctx.submitted })
                    }, "Account Holder", 2),
                    _createVNode(_component_AutoComplete, {
                      delay: 1000,
                      minLength: 3,
                      onItemSelect: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveProfile($event))),
                      scrollHeight: "500px",
                      modelValue: _ctx.v$.selectedProfile.$model,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.selectedProfile.$model) = $event)),
                      suggestions: _ctx.profilerList,
                      placeholder: "Search Profile",
                      onComplete: _cache[11] || (_cache[11] = ($event: any) => (_ctx.searchProfiler($event))),
                      dropdown: false,
                      class: _normalizeClass({
                  'p-invalid': _ctx.v$.selectedProfile.$invalid && _ctx.submitted,
                })
                    }, {
                      item: _withCtx((slotProps) => [
                        _createElementVNode("div", null, [
                          _hoisted_24,
                          _createElementVNode("b", _hoisted_25, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_26,
                          _createElementVNode("span", _hoisted_27, _toDisplayString(slotProps.item.email_address), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_28,
                          _createElementVNode("span", _hoisted_29, _toDisplayString(slotProps.item.contact_no), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_30,
                          _createElementVNode("span", _hoisted_31, _toDisplayString(slotProps.item.account_type), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "suggestions", "class"]),
                    (_ctx.v$.selectedProfile.$error && _ctx.submitted)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.selectedProfile.$errors, (error, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              id: "p-error",
                              key: index
                            }, [
                              _createElementVNode("small", _hoisted_33, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : (
                  (_ctx.v$.selectedProfile.$invalid && _ctx.submitted) ||
                  _ctx.v$.selectedProfile.$pending.$response
                )
                        ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(_ctx.v$.selectedProfile.required.$message.replace(
                    "Value",
                    "Account Holder"
                  )), 1))
                        : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", {
                  for: "accountHead",
                  class: _normalizeClass({ 'p-error': _ctx.v$.accountHead.$invalid && _ctx.submitted })
                }, "Account Head", 2),
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveAccountHead($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.v$.accountHead.$model,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.accountHead.$model) = $event)),
                  suggestions: _ctx.accountHeadList,
                  placeholder: "Search Account",
                  onComplete: _cache[14] || (_cache[14] = ($event: any) => (_ctx.searchAccountHead($event))),
                  dropdown: false,
                  class: _normalizeClass([{ 'p-invalid': _ctx.v$.accountHead.$invalid && _ctx.submitted }, "p-p-1"])
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _hoisted_36,
                      _createElementVNode("b", _hoisted_37, _toDisplayString(slotProps.item.account_code.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_38,
                      _createElementVNode("b", _hoisted_39, _toDisplayString(slotProps.item.account_name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_40,
                      _createElementVNode("span", _hoisted_41, _toDisplayString(slotProps.item.account_nature), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_42,
                      _createElementVNode("span", _hoisted_43, _toDisplayString(slotProps.item.account_type), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions", "class"]),
                (_ctx.v$.accountHead.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.accountHead.$errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          id: "p-error",
                          key: index
                        }, [
                          _createElementVNode("small", _hoisted_45, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (
                  (_ctx.v$.accountHead.$invalid && _ctx.submitted) ||
                  _ctx.v$.accountHead.$pending.$response
                )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_46, _toDisplayString(_ctx.v$.accountHead.required.$message.replace(
                    "Value",
                    "Account Head"
                  )), 1))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("label", {
                  for: "receiptNo",
                  class: _normalizeClass({ 'p-error': _ctx.v$.receiptNo.$invalid && _ctx.submitted })
                }, "Cheque or Transaction No", 2),
                _createVNode(_component_InputText, {
                  id: "receiptNo",
                  modelValue: _ctx.v$.receiptNo.$model,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.receiptNo.$model) = $event)),
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.receiptNo.$invalid && _ctx.submitted })
                }, null, 8, ["modelValue", "class"]),
                (
                  (_ctx.v$.receiptNo.$invalid && _ctx.submitted) ||
                  _ctx.v$.receiptNo.$pending.$response
                )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_48, _toDisplayString(_ctx.v$.receiptNo.required.$message.replace(
                    "Value",
                    "Cheque or Transaction No"
                  )), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("label", {
                  for: "description",
                  class: _normalizeClass({ 'p-error': _ctx.v$.description.$invalid && _ctx.submitted })
                }, "Description", 2),
                _createVNode(_component_InputText, {
                  id: "description",
                  modelValue: _ctx.v$.description.$model,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.description.$invalid && _ctx.submitted })
                }, null, 8, ["modelValue", "class"]),
                (
                  (_ctx.v$.description.$invalid && _ctx.submitted) ||
                  _ctx.v$.description.$pending.$response
                )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_50, _toDisplayString(_ctx.v$.description.required.$message.replace(
                    "Value",
                    "Description"
                  )), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.bankingActionDialog,
        "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.bankingActionDialog) = $event)),
        style: { width: '40vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _hoisted_51
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Save",
            icon: "pi pi-check",
            class: "p-button-primary",
            onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.updateBankActivity()), ["prevent"])),
            disabled: _ctx.item.id == 0
          }, null, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.item.status,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.item.status) = $event)),
                  options: _ctx.chequeActivity,
                  optionLabel: "name",
                  optionValue: "name"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_SearchFilter, {
        searchDetail: {
          status: this.filterDialog,
          dialogTitle: this.dialogTitle,
        },
        onUpdateFilterStatus: _ctx.updateFilterStatus
      }, null, 8, ["searchDetail", "onUpdateFilterStatus"]),
      _createVNode(_component_PreviewBankingReceipt, {
        PreviewReceipt: {
          status: this.previewImageDialog,
          dialogTitle: this.dialogTitle,
          previewHeading: this.previewHeading,
          receiptID: this.receiptID,
        },
        onUpdatePreviewStatus: _ctx.updatePreviewStatus
      }, null, 8, ["PreviewReceipt", "onUpdatePreviewStatus"])
    ])
  ]))
}